import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

export function ForgotPasswordPage() {
  const { t } = useTranslation();

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>{t('forgotPassword.title')}</h1>
        <p>{t('forgotPassword.instructions')}</p>
        <ol style={{ textAlign: 'left', margin: '1rem 0', paddingLeft: '1.5rem' }}>
          <li>{t('forgotPassword.step1')}</li>
          <li><Trans i18nKey="forgotPassword.step2" /></li>
          <li><Trans i18nKey="forgotPassword.step3" /></li>
        </ol>

        <a href="/auth/idprism/login" className="btn-primary" style={{ display: 'block', textAlign: 'center', width: '100%' }}>
          {t('common.continue')}
        </a>

        <div className="login-links" style={{ textAlign: 'center' }}>
          <Link to="/login">{t('common.backToSignIn')}</Link>
        </div>
      </div>
    </div>
  );
}
